Monitoring.Views ||= {}

class AccountSettings.DragableListView extends Backbone.View
  template: JST["backbone/templates/account_settings/acd_setting/dragable_list"]

  initialize: (@options = {}) ->
    @selections = []

  render: =>
    @$el.html(@template())
#    @enableSortableList()
    @

  addNewSelection:(selectionView) =>
    existing_filter = _.find @selections, (selection) -> selection.filter.filter_id == selectionView.filter.filter_id
    if existing_filter
      swal(I18n.t('monitoring.acd_setting.filter_already_selected'), "",  "error");
    else
      @selections.push(selectionView)
      selectionView.bind('selection:remove', @onRemoveSelection)
      @$el.find('.selections-list').append(selectionView.render().el)

  unbindAllRemoveButton: ->
    _.each @selections, (s) =>
      s.unbind('selection:remove')

  resetAllSelectedTrays: ->
    _.each @selections, (s) =>
      @onRemoveSelection(s)

  rebindAllRemoveButton: ->
    _.each @selections, (s) =>
      s.bind('selection:remove', @onRemoveSelection)

  onRemoveSelection: (selectionView) =>
    @selections = _.without(@selections, selectionView)
    selectionView.remove()

  toJson:->
    list = []
    _.map @selections, (s) =>
      list.push(s.toJson())
    list

  updateTraysOrder: =>
    @selections = []
    new_orderdered_list = []
    _.each(@$el.find('.selected_filter'), (selection) =>
      filter_name_tokens = $(selection).find(".tray_name").html().split("|")
      filter = {filter_id: $(selection).find(".tray_name").attr('data-tray-id'), filter_name: filter_name_tokens[0].trim() + ' | ' + filter_name_tokens[1].trim() }
      order = {order_code: $(selection).find(".tray_order").attr('data-tray-order-code'), order_text: $(selection).find(".tray_order").html(), full_order_text: $(selection).find(".tray_order").attr('title') }
      selectionView = new AccountSettings.FilterAndOrderSelectionView({filter: filter, order: order})
      new_orderdered_list.push(selectionView)

    )
    @$el.find('.selections-list').html('');
    _.each(new_orderdered_list, (new_element) =>
      @addNewSelection(new_element)
    )

  enableSortableList: =>
    @$el.find('.selections-list').sortable
      disabled: false
      placeholder: 'sortable-trays-placeholder'
      cursor: 'grabbing'
      update: @updateTraysOrder
      start: @enableSortHint
      stop: @disableSortHint
    @$el.find('.selected_filter').removeClass("disabled_link")
    @$el.find('.selected_filter').removeClass("disabled_background")

  disableSortableList: =>
    @$el.find('.selections-list').sortable({
      disabled: true
    });
    @$el.find('.selected_filter').addClass("disabled_link")
    @$el.find('.selected_filter').addClass("disabled_background")

  enableSortHint: (event,ui)=>
    $(ui.item).find(".draggable-hint").addClass("draggable-hint-active")


  disableSortHint: (event,ui)=>
    $(ui.item).find(".draggable-hint").removeClass("draggable-hint-active")
